import React from 'react'
import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux'

const LanguageProvider = ({ children }) => {
	const { messages, locale } = useSelector((state) => state.root)
	return (
		<IntlProvider messages={messages[locale]} locale={locale}>
			{children}
		</IntlProvider>
	)
}

export default LanguageProvider
